export function getFeatures(theme) {
  return [
    {
      id: 'real-time-orders',
      title: 'Real-time Orders',
      description:
        'Track orders as they happen with instant notifications and live updates. Never miss an order again with our real-time order management system.',
      icon: 'solar:clock-circle-bold-duotone',
      color: theme.palette.primary.main,
      benefits: [
        'Instant order notifications',
        'Live order tracking',
        'Real-time status updates',
        'Order history analytics',
      ],
      image: '/assets/illustrations/illustration_dashboard.png',
    },
    {
      id: 'transparent-pricing',
      title: 'Transparent Pricing',
      description:
        'Complete visibility into your pricing structure with real-time cost tracking, margin analysis, and competitive pricing insights.',
      icon: 'solar:chart-2-bold-duotone',
      color: theme.palette.success.main,
      benefits: [
        'Real-time cost tracking',
        'Margin analysis tools',
        'Competitive pricing insights',
        'Price history tracking',
      ],
      image: '/assets/illustrations/illustration_dashboard.png',
    },
    {
      id: 'inventory-management',
      title: 'Inventory Management',
      description:
        'Smart inventory tracking with automated reorder points, stock level monitoring, and predictive analytics to prevent stockouts.',
      icon: 'solar:box-bold-duotone',
      color: theme.palette.warning.main,
      benefits: [
        'Automated reorder points',
        'Stock level monitoring',
        'Predictive analytics',
        'Multi-location inventory',
      ],
      image: '/assets/illustrations/illustration_dashboard.png',
    },
    {
      id: 'in-app-communication',
      title: 'In-app Communication',
      description:
        'Seamless communication between restaurants and suppliers with built-in messaging, file sharing, and collaboration tools.',
      icon: 'solar:chat-round-dots-bold-duotone',
      color: theme.palette.info.main,
      benefits: [
        'Built-in messaging system',
        'File sharing capabilities',
        'Collaboration tools',
        'Communication history',
      ],
      image: '/assets/illustrations/illustration_dashboard.png',
    },
    {
      id: 'multi-location-support',
      title: 'Multi-location Support',
      description:
        'Manage multiple restaurant locations from a single dashboard with centralized control and location-specific settings.',
      icon: 'solar:map-point-bold-duotone',
      color: theme.palette.secondary.main,
      benefits: [
        'Centralized management',
        'Location-specific settings',
        'Unified reporting',
        'Cross-location analytics',
      ],
      image: '/assets/illustrations/illustration_dashboard.png',
    },
  ];
}

/**
 * Get detailed feature description
 * @param {string} featureId - ID of the feature
 * @returns {string} - Detailed description of the feature
 */
export function getFeatureDetails(featureId) {
  const details = {
    'real-time-orders':
      'Our real-time order system provides instant notifications, live tracking, and comprehensive order history. Restaurants can monitor order status in real-time, receive instant alerts for new orders, and track delivery progress. The system integrates seamlessly with your existing POS and provides detailed analytics to optimize your order management workflow.',
    'transparent-pricing':
      'Get complete visibility into your pricing structure with our advanced analytics. Track costs in real-time, analyze profit margins, and gain insights into competitive pricing. Our system provides historical pricing data, cost breakdowns, and automated alerts for price changes, helping you make informed pricing decisions.',
    'inventory-management':
      'Smart inventory tracking with automated reorder points and predictive analytics. Monitor stock levels across multiple locations, set custom reorder thresholds, and receive alerts before stockouts occur. Our AI-powered system analyzes usage patterns to predict future demand and optimize inventory levels.',
    'in-app-communication':
      'Built-in messaging and collaboration tools for seamless communication between restaurants and suppliers. Share files, discuss orders, and maintain communication history all within the platform. No more lost emails or missed messages - everything is organized and searchable.',
    'multi-location-support':
      'Manage multiple restaurant locations from a single, centralized dashboard. Each location can have its own settings, inventory, and pricing while sharing common suppliers and analytics. Our unified reporting system gives you insights across all locations for better decision-making.',
  };
  return details[featureId] || 'Detailed information about this feature will be available soon.';
}
